import React from "react";

import { MedicalPlanMapping } from "Features/MedicalPlanMappings/medicalPlanMappings.types";
import { useHistory } from "react-router-dom";

import { CostsComparison } from "../components";
import { baseURL } from "../urls";
import { TitleSmall } from "Cobalt/Header";
import { Grid } from "Common/Grid";
import BodyText from "Theme/BodyText";
import { LinkButton } from "Theme/Button";

interface DetailedCostsComparisonPageProps {
  medicalPlanMappings?: MedicalPlanMapping[];
}
const DetailedCostsComparisonPage = ({ medicalPlanMappings }: DetailedCostsComparisonPageProps) => {
  const history = useHistory();
  return (
    <>
      <div className="bg-white">
        <Grid pb={6}>
          <LinkButton
            onClick={() => {
              history.push(baseURL);
            }}
            color="link"
            role="link"
            px={0}
            my={4}
          >
            Back
          </LinkButton>
          <TitleSmall mt={0} mb={5}>
            Compare expected costs across renewal options
          </TitleSmall>
          <BodyText>Monthly contributions and deductions are adjusted based on new premium prices.</BodyText>
        </Grid>
      </div>
      <Grid py={6}>
        <CostsComparison medicalPlanMappings={medicalPlanMappings} />
      </Grid>
    </>
  );
};

export default DetailedCostsComparisonPage;
